import { client } from '@/common/lib/fetch'
import { client as apiClient } from '@/common/api/client/client.gen'

let configured = false

export const initApiClient = (): void => {
    if (configured) return
    const baseURL = __ENDPOINTS_HOST__
    apiClient.setConfig({
        axios: client,
        throwOnError: true,
        baseURL,
    })
    configured = true
}
